/* eslint-disable  */
/* eslint-disable react/prop-types */
/* eslint-disable import/no-unresolved */
/* eslint-disable global-require */
/* eslint-disable  */
//@ts-nocheck
import React, { useState, useEffect, useRef } from 'react';
import {
  Grid,
  Container,
  InputLabel,
  Box,
  Paper,
  InputAdornment,
  SwipeableDrawer,
  Typography,
  Autocomplete,
  IconButton,
  TextField,
  Button,
  Divider,
  Link,
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import KeyboardArrowLeftOutlinedIcon from '@mui/icons-material/KeyboardArrowLeftOutlined';
import KeyboardArrowRightOutlinedIcon from '@mui/icons-material/KeyboardArrowRightOutlined';
import CloseIcon from '@mui/icons-material/Close';
import GroutColors from '../../../../components/GroutColors/GroutColors.components';
import NavigationSteps from '../../../../components/NavigationSteps/NavigationSteps.components';
import AddIcon from '@mui/icons-material/Add';
import CheckIcon from '@mui/icons-material/Check';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { imgPreview } from '../../../../services/image-crop/imagePreview';
import RenderGroutColors from '../../../../services/grout-colors/RenderGroutColors';
import { useAppSelector } from '../../../../store/hooks';
import { setGroutColorData } from '../../../../store/tile.slice';
import { useDispatch } from 'react-redux';
import { store } from '../../../../store/store';

type GroutColorType = {
  [key: string]: { id: string; name: string; backgroundColor: string } | null;
};

export const groutColors = [
  { id: '#640', name: 'Arctic   ', backgroundColor: `#f2f3f4` },
  { id: '#381', name: 'Bright White', backgroundColor: `#ebe9df` },
  { id: '#11', name: 'Snow White', backgroundColor: `#e1dbce` },
  { id: '#641', name: 'Cool White', backgroundColor: `#edf1f3` },
  { id: '#642', name: 'Ash', backgroundColor: `#ededec` },
  { id: '#545', name: 'Bleached Wood', backgroundColor: `#e1ded8` },
  { id: '#333', name: 'Alabaster', backgroundColor: `#ded8c8` },
  { id: '#10', name: 'Antique White', backgroundColor: `#d8ceb8` },
  { id: '#382', name: 'Bone', backgroundColor: `#d1c5b0` },
  { id: '#643', name: 'Warm Gray', backgroundColor: `#c9c4c6` },
  { id: '#544', name: 'Rolling Fog', backgroundColor: `#cbc9c5` },
  { id: '#115', name: 'Platinum', backgroundColor: `#babfbf` },
  { id: '#546', name: 'Cape Gray', backgroundColor: `#b2b4b3` },
  { id: '#386', name: 'Oyster Gray', backgroundColor: `#b6ad9f` },
  { id: '#543', name: 'Driftwood ', backgroundColor: `#a7a29b` },
  { id: '#542', name: 'Graystone', backgroundColor: `#B0A8A0` },
  { id: '#165', name: 'Delorean Gray', backgroundColor: `#9B9797` },
  { id: '#335', name: 'Winter Gray', backgroundColor: `#85817D` },
  { id: '#09', name: 'Natural Gray', backgroundColor: `#7F7F74` },
  { id: '#19', name: 'Pewter', backgroundColor: `#797779` },
  { id: '#644', name: 'Shadow', backgroundColor: `#726974` },
  { id: '#370', name: 'Dove Gray', backgroundColor: `#5C5F63` },
  { id: '#645', name: 'Steel Blue', backgroundColor: `#586876` },
  { id: '#122', name: 'Linen', backgroundColor: `#D2BC9C` },
  { id: '#183', name: 'Chateau', backgroundColor: `#A89C8D` },
  { id: '#172', name: 'Urban Putty', backgroundColor: `#C5B79F` },
  { id: '#380', name: 'Haystack', backgroundColor: `#B59F87` },
  { id: '#186', name: 'Khaki', backgroundColor: `#B09B82` },
  { id: '#135', name: 'Mushroom', backgroundColor: `#AC9583` },
  { id: '#145', name: 'Light Smoke', backgroundColor: `#A69680` },
  { id: '#541', name: 'Walnut', backgroundColor: `#8D827A` },
  { id: '#185', name: 'New Taupe', backgroundColor: `#6E665D` },
  { id: '#105', name: 'Earth', backgroundColor: `#907966` },
  { id: '#59', name: 'Saddle Brown', backgroundColor: `#786855` },
  { id: '#52', name: 'Tobacco Brown', backgroundColor: `#746155` },
  { id: '#646', name: 'Coffee Bean', backgroundColor: `#5D4738` },
  { id: '#95', name: 'Sable Brown', backgroundColor: `#614D47` },
  { id: '#647', name: 'Brown Velvet', backgroundColor: `#5F5150` },
  { id: '#540', name: 'Truffle', backgroundColor: `#615A55` },
  { id: '#60', name: 'Charcoal', backgroundColor: `#3D3D3D` },
];

const SelectGroutColors = ({ dialog }: { dialog?: boolean }) => {
  const { state } = useLocation();
  const [selectedTile, setSelectedTile] = useState('tileOne');
  const [groutColor, setGroutColor] = useState<GroutColorType>({
    tileOne: null,
    tileTwo: null,
    tileThree: null,
    selected: null,
  });

  const { selectedTileData, selectedGroutColorData } = useAppSelector((state) => {
    return state.tile;
  });

  // const {
  //   tile: { selectedTileData, selectedGroutColorData },
  // } = store.getState();

  const location = useLocation();

  useEffect(() => {
    if (!location.hash) {
      window.scrollTo(0, 0);
    }
  }, [location]);

  useEffect(() => {
    if (selectedGroutColorData) {
      setGroutColor(selectedGroutColorData);
      // if (selectedGroutColorData.selected) {
      //   setSelectedTile(selectedGroutColorData.selected);
      // }
    }
  }, [selectedGroutColorData, dialog]);

  // useEffect(() => {
  //   const imagePreviewFn = async () => {
  //     if (groutColor && selectedTile) {
  //       const renderImg = await imgPreview(imgRef.current, completedCrop, 1, 0, false);
  //       setGroutedTile({ ...groutedTile, [selectedTile]: { img: renderImg, color: groutColor } });
  //     }
  //   };
  //   imagePreviewFn();
  // }, [groutColor]);

  const groutColorName = (row: string) => {
    return (
      <Box className="GroutColourName">
        {groutColor[row] ? (
          <Box className="GroutColourInner">
            <Typography variant="h6"> {groutColor[row]?.id}</Typography>
            <Typography variant="body2" className="ColourName">
              {groutColor[row]?.name}
            </Typography>
          </Box>
        ) : (
          <Box className="GroutColourInner">
            <Typography variant="h6">
              <AddIcon className="OrangeColor" />
            </Typography>
            <Typography variant="body2" className="ColourName">
              Select color
            </Typography>
          </Box>
        )}
      </Box>
    );
  };

  const selectedGroutColorCss = (colorId: string) => {
    if (
      groutColor['tileOne']?.id === colorId ||
      groutColor['tileTwo']?.id === colorId ||
      groutColor['tileThree']?.id === colorId
    ) {
      return `GroutColorButton Selected ${
        groutColor[selectedTile]?.id === colorId ? '' : 'ExistingSelected'
      }`;
    } else {
      return 'GroutColorButton';
    }
  };

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleBack = () => {
    navigate('../visualizer/configure-tile');
  };

  const handleClick = () => {
    if (groutColor.tileOne && groutColor.tileTwo && groutColor.tileThree) {
      dispatch(setGroutColorData({ ...groutColor, selected: 'tileOne' }));
      navigate('../visualizer/room/select');
    }
  };

  const tileImage = selectedTileData && selectedTileData?.tile;
  const tileShape = selectedTileData && selectedTileData?.shape?.label;

  const handleGroutColor = (tileColor) => {
    setGroutColor(tileColor);
    if (dialog) {
      dispatch(setGroutColorData({ ...groutColor, ...tileColor }));
    }
  };

  const stepsData = { step: '2', label: 'Select Grout Colors' };
  // Start Drawer Code
  const [open, setOpen] = React.useState(false);
  const toggleDrawer = (newOpen: boolean) => () => {
    setOpen(newOpen);
  };
  const SelectGroutColourClose = () => {
    setOpen(false);
  };
  // End Drawer Code

  const [matchingColors, setMatchingColors] = useState([]);
  const [searchValue, setSearchValue] = useState('');

  const handleSearch = (e) => {
    const searchName = e.target.value;
    setSearchValue(searchName);
  };

  useEffect(() => {
    const matchingColors = groutColors?.filter((color) => {
      const id = color.id.toLowerCase();
      const name = color.name.toLowerCase();
      const searchTermLower = searchValue.toLowerCase();

      const idRelevance = id.includes(searchTermLower) ? 1 : 0;
      const nameRelevance = name.includes(searchTermLower) ? 1 : 0;
      const relevance = idRelevance + nameRelevance;

      return relevance > 0 ? { ...color, relevance } : null;
    });

    matchingColors.sort((a, b) => b.relevance - a.relevance);
    setMatchingColors(matchingColors);
  }, [searchValue]);

  return (
    <Grid container direction="row">
      <Grid size={12}>
        {!dialog && (
          <Grid container direction="row" columnSpacing={4} className="GridRow" paddingBottom={0}>
            <NavigationSteps
              handleClick={handleClick}
              handleBack={handleBack}
              stepsData={stepsData}
              forward={groutColor.tileOne && groutColor.tileTwo && groutColor.tileThree}
            />
          </Grid>
        )}
        <Box className="SelectGroutColourGrid LightSkyBlue">
          {!tileImage ? (
            <p>Please go back and select tile</p>
          ) : (
            <Container maxWidth="sm" disableGutters>
              <Grid
                container
                direction="row"
                className=""
                columnSpacing={2}
                sx={{ justifyContent: 'flex-start' }}
              >
                <Grid size={4}>
                  <Box
                    className={`GroutColourGrid ${selectedTile === 'tileOne' ? 'Selected' : ''}`}
                    onClick={() => setSelectedTile('tileOne')}
                  >
                    <Box className="GroutGridColourCanvas GroutGridColourCanvasSelected" id="123">
                      <RenderGroutColors
                        tileImage={tileImage}
                        groutColor={groutColor.tileOne?.backgroundColor || '#FFF'}
                        shape={tileShape}
                      />
                    </Box>
                    {groutColorName('tileOne')}
                  </Box>
                </Grid>
                <Grid size={4}>
                  <Box
                    className={`GroutColourGrid ${selectedTile === 'tileTwo' ? 'Selected' : ''}`}
                    onClick={() => setSelectedTile('tileTwo')}
                  >
                    <Box className="GroutGridColourCanvas GroutGridColourCanvasSelected">
                      <RenderGroutColors
                        tileImage={tileImage}
                        groutColor={groutColor.tileTwo?.backgroundColor || '#FFF'}
                        shape={tileShape}
                      />
                    </Box>
                    {groutColorName('tileTwo')}
                  </Box>
                </Grid>
                <Grid size={4}>
                  <Box
                    className={`GroutColourGrid ${selectedTile === 'tileThree' ? 'Selected' : ''}`}
                    onClick={() => setSelectedTile('tileThree')}
                  >
                    <Box className="GroutGridColourCanvas GroutGridColourCanvasSelected">
                      <RenderGroutColors
                        tileImage={tileImage}
                        groutColor={groutColor.tileThree?.backgroundColor || '#FFF'}
                        shape={tileShape}
                      />
                    </Box>
                    {groutColorName('tileThree')}
                  </Box>
                </Grid>
              </Grid>
            </Container>
          )}
        </Box>

        <Container maxWidth="sm" disableGutters>
          <Box className="SelectGroutColourOptions">
            {/* Start SearchBox */}
            <Paper className="SearchBox">
              <Button className="SearchButton" variant="outlined" onClick={toggleDrawer(true)}>
                <SearchIcon />
                Search
              </Button>
              <Box>
                <SwipeableDrawer
                  className="SwipeableDrawerBox"
                  // container={container}
                  anchor="left"
                  open={open}
                  onClose={toggleDrawer(false)}
                  onOpen={toggleDrawer(true)}
                  // swipeAreaWidth={drawerBleeding}
                  disableSwipeToOpen={false}
                  ModalProps={{
                    keepMounted: true,
                  }}
                >
                  <Paper className="SearchContentBox CommonDrawerBox">
                    <Box className="SearchBar">
                      <TextField
                        value={searchValue}
                        autoFocus={true}
                        placeholder="Enter name or #"
                        onChange={handleSearch}
                        label=""
                        variant="outlined"
                        className="SearchInput"
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <SearchIcon />
                            </InputAdornment>
                          ),
                          endAdornment: (
                            <InputAdornment position="end">
                              <CloseIcon onClick={() => setSearchValue('')} />
                            </InputAdornment>
                          ),
                        }}
                      />
                      <Button className="SelectedTileEditButton" onClick={SelectGroutColourClose}>
                        Cancel
                      </Button>
                    </Box>
                    <Box className="SearchResult">
                      {matchingColors?.length > 0 ? (
                        matchingColors?.map((v) => (
                          <Box
                            key={v.id}
                            className={`SearchResultInfo ${
                              v?.backgroundColor === groutColor[selectedTile]?.backgroundColor
                                ? 'Selected'
                                : ''
                            }`}
                            onClick={() => {
                              const tileColor = {
                                ...groutColor,
                                [selectedTile]: v,
                              };
                              handleGroutColor(tileColor);
                              SelectGroutColourClose();
                            }}
                          >
                            <Box
                              className="SearchGroutColor"
                              style={{
                                backgroundColor: v?.backgroundColor,
                              }}
                            ></Box>
                            <Typography variant="body2" component="span">
                              {`${v.id} ${v.name}`}
                            </Typography>
                          </Box>
                        ))
                      ) : (
                        <Box className="NoResult">
                          <Typography variant="body1">
                            <em>No results found</em>
                          </Typography>
                        </Box>
                      )}
                    </Box>
                  </Paper>
                </SwipeableDrawer>
              </Box>
            </Paper>
            {/* end SearchBox */}
            <Box>
              <Typography variant="h5">GROUT COLOR (40 OPTIONS)</Typography>
            </Box>
            <Box className="SelectGroutColourSlider"></Box>
            {/* <Box className="SelectGroutColourName">
            <Typography variant="h5">
              <span className="DisableColour">No Color Selected</span>
              <span>#11 - Snow White</span>
            </Typography>
          </Box> */}
            <Paper>
              <Box className="GroutColorOptionContent">
                <Button
                  variant="outlined"
                  onClick={() => {
                    const tileColor = {
                      ...groutColor,
                      [selectedTile]: null,
                    };
                    handleGroutColor(tileColor);
                  }}
                  className={`NoGroutButton ${
                    !groutColor[selectedTile] ? 'GroutColorButton Selected' : 'GroutColorButton'
                  }`}
                >
                  <div className="line1"></div>
                  <CheckIcon className="CheckIcon" />
                </Button>
                {groutColors.map((color) => (
                  <Button
                    key={color.id}
                    variant="outlined"
                    className={selectedGroutColorCss(color.id)}
                    style={{
                      backgroundColor: color.backgroundColor,
                    }}
                    onClick={() => {
                      const tileColor = {
                        ...groutColor,
                        [selectedTile]: color,
                      };
                      handleGroutColor(tileColor);
                    }}
                  >
                    <CheckIcon className="CheckIcon" />
                  </Button>
                ))}
                <Grid size={12} className="BottomNextButton">
                  <Button
                    variant="contained"
                    color="primary"
                    startIcon={<KeyboardArrowLeftOutlinedIcon />}
                    onClick={handleBack}
                  >
                    Back
                  </Button>
                  &nbsp;&nbsp;
                  <Button
                    variant="contained"
                    color="primary"
                    endIcon={<KeyboardArrowRightOutlinedIcon />}
                    onClick={handleClick}
                    disabled={!(groutColor.tileOne && groutColor.tileTwo && groutColor.tileThree)}
                  >
                    Next
                  </Button>
                </Grid>
              </Box>
            </Paper>
          </Box>
        </Container>
      </Grid>
    </Grid>
  );
};

export default SelectGroutColors;
